// Hook - slownik etapow pipeline Deal (7 stages z tlumaczeniami)
// GET /api/ui/sales-crm/deals/stages

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IGetDealStagesDictionaryResponse } from 'api/types/deals';

const getDealStagesDictionary = (): Promise<IGetDealStagesDictionaryResponse> =>
  axios.get(`/sales-crm/deals/stages`);

export const useGetDealStagesDictionary = (
  options?: UseQueryOptions<IGetDealStagesDictionaryResponse, IError>,
) =>
  useQuery<IGetDealStagesDictionaryResponse, IError>(
    ['sales-crm-deal-stages'],
    getDealStagesDictionary,
    {
      staleTime: 5 * 60 * 1000, // 5 min - slownik etapow rzadko sie zmienia
      ...options,
    },
  );
